import TakeOutScreen from 'features/lineOfCredit/screens/takeOut/TakeOutScreen';
import React from 'react';

export default function Page() {
  return <TakeOutScreen />;
}
